import {createBarbaPage} from '../baseBarbaPage';

export default  createBarbaPage({
    namespace: 'partner',
    onEnter: function() {
        // The new Container is ready and attached to the DOM.
    },
    onEnterCompleted: function() {
        // The Transition has just finished.
    },
    onLeave: function() {
        // A new Transition toward a new page has just started.

    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
});


// !!!! Don't forget to init the view in page-transitions/barba-init.js !!!!!